export default {
  current: state =>  state.current.data,
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/notices/getters.js
// module id = null
// module chunks = 